import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VueFire from 'vuefire'
import VueSimpleSVG from 'vue-simple-svg'

Vue.config.productionTip = false

Vue.use(VueFire)
Vue.use(VueSimpleSVG)

// check current user has access to ranges
store.watch(
  () => store.getters['ranges/currentRanges'], currentRanges => {
    if (router.currentRoute.name === 'ranges_path' && currentRanges.length > 0) {
      let currentUser = store.getters['auth/currentUser']
      let currentRangeCourse = currentRanges['0'].courseId
      let exists = currentUser.courses.some(course => course.id === currentRangeCourse)

      if (!exists) {
        router.push({ name: 'home' })
      }
    }
  }
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
